import TruckTemplateState from '../state/TruckTemplateState';
import { Action } from '../actions';
import { ActionType } from '../actions/truck-template';

const truckTemplateReducer = (state: TruckTemplateState = { templates: [] }, action: Action) => {
  switch (action.type) {
    case ActionType.GET_TRUCK_TEMPLATES_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case ActionType.GET_TRUCK_TEMPLATES_SUCCESS:
      return {
        loading: false,
        templates: action.data,
      };

    case ActionType.GET_TRUCK_TEMPLATES_FAILURE:
      return {
        ...state,
        loading: false,
      };

    case ActionType.CREATE_TRUCK_TEMPLATES_SUCCESS:
      return {
        templates: [
          ...state.templates,
          action.data,
        ],
      };

    case ActionType.UPDATE_TRUCK_TEMPLATES_SUCCESS:
      return {
        templates: state.templates.map(
          template =>
            template.id === action.data.id
              ? action.data
              : template,
        ),
      };

    case ActionType.DELETE_TRUCK_TEMPLATES_SUCCESS:
      return {
        templates: state.templates.filter(
          template => template.id !== action.data,
        ),
      };
  }
  return state;
};

export default truckTemplateReducer;
